import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-recommend-group-1 -is-accordion" }
const _hoisted_2 = { class: "p-recommend-group-1__head js-acc-toggle" }
const _hoisted_3 = { class: "p-recommend-heading-1" }
const _hoisted_4 = {
  key: 0,
  class: "p-recommend-notice-1 --color-2"
}
const _hoisted_5 = {
  key: 1,
  class: "p-recommend-notice-1 --color-1"
}
const _hoisted_6 = { class: "p-recommend-group-1__content js-acc-content" }
const _hoisted_7 = { class: "p-recommend-group-1__content-inner" }
const _hoisted_8 = { class: "p-recommend-group-1__body" }
const _hoisted_9 = { class: "p-recommend-heading-2" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "編集する", -1)

import { Field } from '@/types';
import { computed } from 'vue';
type Props = {
    fields: Field[];
    isShowLable: boolean;
    isRequiredFields: boolean;
    headerGroup: string;
    editUrl: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CommonFieldList',
  props: {
    fields: null,
    isShowLable: { type: Boolean },
    isRequiredFields: { type: Boolean },
    headerGroup: null,
    editUrl: null
  },
  setup(__props: any) {

const props = __props as {
    fields: Field[];
    isShowLable: boolean;
    isRequiredFields: boolean;
    headerGroup: string;
    editUrl: string;
}


const visibleFields = computed(() => {
    return props.fields
        .filter(field => !field.hidden);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(props.headerGroup), 1),
      (__props.isRequiredFields && __props.isShowLable)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "入力済"))
        : _createCommentVNode("", true),
      (!(__props.isRequiredFields) && __props.isShowLable)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "未入力あり"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleFields), (field) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "p-recommend-set",
              key: field.key
            }, [
              _createElementVNode("h3", _hoisted_9, _toDisplayString(field.label), 1),
              _createElementVNode("p", {
                class: "p-recommend-text-1",
                innerHTML: field.value
              }, null, 8, _hoisted_10)
            ])), [
              [_vShow, !field.hidden]
            ])
          }), 128))
        ]),
        _createVNode(_component_router_link, {
          to: props.editUrl,
          class: "p-recommend-button --type-1"
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}
}

})